{
    "ReportIntervalLanguageFifteenMinutes": "15 Minutes",
    "ReportIntervalLanguageThirtyMinutes": "30 Minutes",
    "ReportIntervalLanguageOneHour": "1 Hour",
    "ReportIntervalLanguageTwoHour": "2 Hours",
    "ReportIntervalLanguageTypeMinute": "Minutes",
    "ReportIntervalLanguageTypeHour": "Hour",
    "ReportIntervalLanguageTypeHourPluralised": "Hours",
    "ReportIntervalLanguageInterpolated": "Total Calls By {} {}",
    "ReportIntervalLanguageCallByInterpolated": "Calls By {} {}",
    "ReportIntervalLanguageCallByNoValueInterpolated": "Calls By {}",
    "ReportIntervalTypeMinutes": "Minutes",
    "ReportIntervalTypeHours": "Hours",
    "ReportIntervalTypeDay": "Day",
    "ReportIntervalTypeWeek": "Week",
    "ReportIntervalTypeMonth": "Month",
    "NAME": "ReportIntervalLanguage"
}